<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">Reports — {{ data.title || 'Utsav' }}</span>
    <button type="button" class="close-btn" (click)="close()" aria-label="Close">×</button>
  </div>

  @if(summary){
  <div class="summary-grid">
    <div class="summary-item"><span class="summary-label">Total bookings</span><span class="summary-value">{{ summary.total }}</span></div>
    <div class="summary-item"><span class="summary-label">Open</span><span class="summary-value">{{ summary.open }}</span></div>
    <div class="summary-item"><span class="summary-label">Waitlisted</span><span class="summary-value">{{ summary.waitlisted }}</span></div>
    <div class="summary-item"><span class="summary-label">Confirmed</span><span class="summary-value">{{ summary.confirmed }}</span></div>
    <div class="summary-item"><span class="summary-label">Cancelled</span><span class="summary-value">{{ summary.cancelled }}</span></div>
    <div class="summary-item"><span class="summary-label">Checked in</span><span class="summary-value">{{ summary.checkedIn }}</span></div>
    <div class="summary-item"><span class="summary-label">Checked out</span><span class="summary-value">{{ summary.checkedOut }}</span></div>
    <div class="summary-item"><span class="summary-label">Guests (confirmed)</span><span class="summary-value">{{ summary.confirmedGuests }} / {{ summary.guests }}</span></div>
  </div>
  }

  <div class="ac-tabs">
    <button type="button" class="ac-tab" [class.active]="activeTab === 'bookings'" (click)="setTab('bookings')">Bookings</button>
    <button type="button" class="ac-tab" [class.active]="activeTab === 'allocations'" (click)="setTab('allocations')">Allocations</button>
  </div>

  @if(activeTab === 'bookings'){
  <div class="dialog-table">
    <table>
      <thead>
        <tr><th>Booking</th><th>Family code</th><th>Guest</th><th>Type</th><th>Dates</th><th>Guests</th><th>Status</th></tr>
      </thead>
      <tbody>
        @for(row of requisitions; track row.bookingId){
        <tr>
          <td>{{ row.bookingId }}</td>
          <td>{{ row.familyCode || '-' }}</td>
          <td>{{ row.guestName || '-' }}</td>
          <td>{{ row.type }} · {{ row.mode }}</td>
          <td>{{ row.fromDate }} → {{ row.toDate }}</td>
          <td>{{ row.guestCount }}</td>
          <td>{{ row.status }} / {{ row.lifecycleStatus }}</td>
        </tr>
        }
        @if(!isLoading && requisitions.length === 0){
        <tr><td colspan="7" class="empty-row">No bookings for this utsav.</td></tr>
        }
      </tbody>
    </table>
  </div>
  } @else {
  <div class="dialog-table">
    <table>
      <thead>
        <tr><th>Guest house</th><th>Room / hall</th><th>Type</th><th>Capacity</th><th>Booking</th><th>Family code</th><th>Status</th></tr>
      </thead>
      <tbody>
        @for(row of allocations; track row.bookingId + '-' + row.room){
        <tr>
          <td>{{ row.guestHouse }}</td>
          <td>{{ row.room }}</td>
          <td>{{ row.accommoType || '-' }}</td>
          <td>{{ row.capacity }}</td>
          <td>{{ row.bookingId }}</td>
          <td>{{ row.familyCode || '-' }}</td>
          <td>{{ row.status }} / {{ row.lifecycleStatus }}</td>
        </tr>
        }
        @if(!isLoading && allocations.length === 0){
        <tr><td colspan="7" class="empty-row">No rooms allocated yet.</td></tr>
        }
      </tbody>
    </table>
  </div>
  }

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn export-btn" (click)="export('csv')">Download CSV</button>
    <button type="button" class="ac-primary-btn export-btn" (click)="export('pdf')">Download PDF</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
